import React from "react";
import classes from "../ModalReward.module.scss";
import { API_Q_MEDALS_IMAGE } from "../../../constants/api";

import star from "../../../assets/images/rewards/star.png";
import ribbows from "../../../assets/images/rewards/ribbows.png";
import bgMedal from "../../../assets/images/rewards/background_medal.png";
import chest_1 from "../../../assets/images/rewards/chest_1.png";
import light from "../../../assets/images/rewards/light.png";
import { Box } from "@mui/material";

// Componente que renderiza a animação do baú das conquistas
const RewardChest = ({ medalContent }) => {
  
  const MedalsImg = API_Q_MEDALS_IMAGE + "/" + medalContent.image;

  //! Refatorar o SVG animação do baú

  return (
    <Box className={classes.WrapCanvas} id="WrapCanvas">
      <img className={classes.chest} src={chest_1} id="chest" />

      <img className={classes.bgMedal} src={bgMedal} id="bgMedal" />

      <img className={classes.medal} id="medal" src={MedalsImg} />

      <img src={ribbows} className={classes.ribbows} id="ribbows" />

      {Array.from({ length: 8 }).map((_, index) => {
        // Cria o ID de cada estrela que está sendo importada
        const starId = `star${index + 1}`;

        // Monta a classe da estrela usando a classe específica + rotação
        const starClass = `${classes[`star${index + 1}`]} ${
          classes.StarsRotation
        }`;

        return (
          <img
            key={starId}
            src={star} // imagem da estrela
            className={starClass} // classes de estilo e animação
            id={starId} // id individual de cada estrela
          />
        );
      })}

      <img className={classes.starLight1} src={light} id="starLight1" />
      <img className={classes.starLight2} src={light} id="starLight2" />
    </Box>
  );
};

export default RewardChest;
